import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { augInctvFieldDefs } from '@/sc/inctvFieldDefs';
import { useCallback } from 'react';

export const InctvLedgerLineDetail = () => {
  const { entityObj } = useEntityMgr();

  const saleLineEntity = entityObj?.saleLineEntity === 'INDIR_SALE' ? 'INDIR_SALE_LINE' : entityObj?.saleLineEntity;
  const augFieldDefs = (fieldToFieldDef) => {
    augInctvFieldDefs(fieldToFieldDef);

    const saleLineDef = fieldToFieldDef.saleLineId;
    if (saleLineDef && saleLineEntity) {
      saleLineDef.displayName = 'Sale Line';
      saleLineDef.type = 'HYPERLINK';
      saleLineDef.module = 'sc';
      saleLineDef.entity = saleLineEntity;
    }
  };

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.sql = `
      SELECT ledger_line.*, COALESCE(dir_sale_line.code, indir_sale_line.code) sale_line_code
      FROM kr_inctv_ledger_line ledger_line
      LEFT JOIN kr_dir_sale_line dir_sale_line
        ON ledger_line.sale_line_entity = 'DIR_SALE_LINE'
       AND ledger_line.sale_line_id = dir_sale_line.id
      LEFT JOIN kr_indir_sale_line indir_sale_line
        ON ledger_line.sale_line_entity IN ('INDIR_SALE_LINE', 'INDIR_SALE')
       AND ledger_line.sale_line_id = indir_sale_line.id
    `;
  }, []);

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm augFieldDefs={augFieldDefs} augRowsReq={augRowsReq} /> },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="INCTV_LEDGER_LINE" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
